import React from "react";

import { SelectField } from "../../../common/u1/SelectField";
import { EditDialog } from "./EditDialog";
import { CompanySearchField } from "./CompanySearchField";
import { useInsuranceForm } from "./useInsuranceForm";
import { INSURANCE_TYPES } from "./insuranceFields";

/* Add / edit an insurance record. */
export const InsuranceFormModal = ({ editing, onClose, onSaved }) => {
  const {
    type,
    setType,
    insurer,
    setInsurer,
    broker,
    setBroker,
    insurerLocked,
    errors,
    setErrors,
    busy,
    submit,
  } = useInsuranceForm({ editing, onSaved });

  return (
    <EditDialog
      title={editing ? "Edit Insurance Information" : "Add Insurance Information"}
      onClose={onClose}
      ctaLabel="Submit"
      onSubmit={submit}
      submitting={busy}
    >
      <SelectField
        label="Type"
        id="u1-insurance-type"
        value={type}
        placeholder="Select a type…"
        options={INSURANCE_TYPES}
        aria-required="true"
        onChange={(e) => {
          setType(e.target.value);
          setErrors((prev) => ({ ...prev, type: "" }));
        }}
        error={errors.type}
      />

      <CompanySearchField
        className="mt-3.5"
        label="Insurer"
        id="u1-insurance-insurer"
        required={false}
        ariaRequired
        chipLabel="Insurer search"
        placeholder="Search insurer…"
        manualPlaceholder="Enter the insurer's name"
        notFoundPrompt="Can't find the insurer you're looking for?"
        addLabel="Add insurer"
        value={insurer?.registered_company_name || insurer?.name || ""}
        onSelect={(company) => {
          setInsurer(company);
          setErrors((prev) => ({ ...prev, insurer: "" }));
        }}
        /* Transcribed: an existing row's insurer cannot be changed. */
        disabled={insurerLocked}
        error={errors.insurer}
      />

      <CompanySearchField
        className="mt-3.5"
        label={
          <>
            Broker{" "}
            <span className="font-normal text-[var(--muted)]">(optional)</span>
          </>
        }
        id="u1-insurance-broker"
        fieldName="Broker"
        required={false}
        chipLabel="Broker search"
        placeholder="Search broker…"
        manualPlaceholder="Enter the broker's name"
        notFoundPrompt="Can't find the broker you're looking for?"
        addLabel="Add broker"
        value={broker?.registered_company_name || broker?.name || ""}
        onSelect={setBroker}
      />
    </EditDialog>
  );
};

export default InsuranceFormModal;
